import styled from 'styled-components';

import { Grid } from 'components/UI/Grid';

export const AnalysisFullScreenRow = styled(Grid.Row)`
	height: 100vh;
	justify-content: space-evenly;
	width: 100%;
`;
